module.exports = __webpack_public_path__ + "img/1.9aa35498.jpg";